<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 id="regionTitle">{{ $t('common.keywords.regions') }}</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <CardCarousel v-if="regions">
                    <div 
                        class="col-lg-3 col-sm-4 col-xs-6 col-12 no-row-padding mx-auto" 
                        v-for="region in regions"
                        :key="region.id">
                        <ImageCard
                            :title="region.localizedName | localized"
                            :link="region.url"
                            :image="resolveImage(region.image, 'thumb')"
                        />
                    </div>
                </CardCarousel>
                <Spinner v-else></Spinner>
            </div>
        </div>
    </div>
</template>

<script>
import CardCarousel from "@/components/common/CardCarousel";
import Spinner from "@/components/common/Spinner";
import ImageCard from "@/components/level1/ImageCard";

export default {
    name: "RegionCarousel",
    components: {
        CardCarousel,
        Spinner,
        ImageCard
    },
    computed: {
        regions: function() {
            return this.$store.getters.getRegions;
        }
    }
}
</script>

<style lang="scss" scoped>
    #regionTitle {
        color: white;
        text-align: center;
    }
</style>